export enum ViewMode {
  BASE = 'base',
  SLIM = 'slim'
}
